/**
 *
 * Mixin utile per caricare i dati di una dashlet di un gruppo di tab solo quando realmente necessario
 *
 * Lo scenario per cui è stato introdotto è quando i dati dei tab possono cambiare da eventi esterni, per esempio:
 * al cambio di un questionario tutti i tab devono mostrare i dati di quel questionario, ma devono caricarli sono quando sono visibili
 *
 */
hrd.manager.CrossTabLoadDataManagerMixin = hrd.AbstractMixin.extend({
	init: function(ref, options) {
		var defaults = {
			impl: 'hrd.manager.CrossTabLoadDataManagerMixin',
			updateMethodName: undefined
		};
		let settings = $.extend({}, defaults, options);
		this._super(ref, settings);
	},
	registerLoadDataManager: function() {
		if (this.settings.updateMethodName === undefined) {
			console.log(`hrd.manager.CrossTabLoadDataManagerMixin cannot be used because "updateMethodName" settings is not defined in Mixin declaration in "${this._FULL_}"`);
		} else if (!(typeof this[this.settings.updateMethodName] === 'function')) {
			console.log(`hrd.manager.CrossTabLoadDataManagerMixin cannot be used because "${this.settings.updateMethodName}" is not available in "${this._FULL_}"`);
		} else {
			$(this.TAB_ID).on('tab-reactivated', (evt, data) => {
				if (this.__dataNotLoadedYet__) {
					this.__loadDataIfNeeded__();
				}
			});
		}
	},
	reloadData: function() {
		this.__dataNotLoadedYet__ = true;
		this.__loadDataIfNeeded__();
	},
	__loadDataIfNeeded__: function() {
		if (!this.isInsideNotActiveTab()) {
			this[this.settings.updateMethodName]();
			this.__dataNotLoadedYet__ = false;
		}
	}
});
